import readNotifications from '../services/micro/read_notifications'
export const onReadNotification = (id, link, notificationPath) => {
    readNotifications([id])
        .then(_res => {
            if (link) {
                window.location.replace(link)
            } else {
                window.location.href = notificationPath
            }
        })
        .catch(error => {
            console.log('error', error)
        })
}
